// Only attach once
if (!window.updateButtonListenerAttached) {
  window.updateButtonListenerAttached = true;

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("[id^='ProductUpdateButton-']");
    if (!btn) return;

    while (window._pendingVariantFetch) {
      btn.classList.add("loading");
      try {
        await window._pendingVariantFetch;
      } catch (_) {}
    }
    btn.classList.remove("loading");

    btn.classList.add("loading");
    const spinner = btn.querySelector(".loading__spinner");
    if (spinner) spinner.classList.remove("hidden");

    const modal = btn.closest(".quick-add-modal[open]") || document;
    const qtyInput = modal.querySelector("[name='quantity']");
    const variantId = btn.dataset.variantId; // ← now guaranteed to be the latest resolved variant
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    // get old variant id from hidden div

    let modalIsOpen = false;

    let variID = document.getElementById("old-variant-id");
    document.querySelectorAll(".quick-update-btn").forEach((radio) => {
      if (radio.hasAttribute("open")) {
        modalIsOpen = true;
        variID = radio.querySelector("#old-variant-id");
      }
    });

    const oldVariantDiv = modalIsOpen
      ? variID
      : document.getElementById("old-variant-id");

    const oldVariantId = oldVariantDiv
      ? oldVariantDiv.textContent.trim()
      : null;

    // ── Guard against double-clicks ──────────────────────────────────────────

    btn.disabled = true;

    // ── Helper: find a variant in the current cart by variant_id ─────────────
    async function findCartLine(variantId) {
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      const idx = cart.items.findIndex(
        (item) => String(item.variant_id) === String(variantId),
      );
      return idx === -1 ? null : { line: idx + 1, cart };
    }

    // ── Step 1: Remove the old variant (set its quantity to 0) ───────────────
    async function removeOldVariant(oldId) {
      const found = await findCartLine(oldId);
      if (!found) {
        console.warn("Old variant not found in cart — skipping remove:", oldId);
        return;
      }
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ line: found.line, quantity: 0 }),
      });
    }

    // ── Step 2: Add the new variant ──────────────────────────────────────────
    async function addNewVariant(newId, qty) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: newId, quantity: qty }),
      });
      return res.json();
    }

    try {
      if (oldVariantId) {
        await removeOldVariant(oldVariantId);
      }
      await addNewVariant(variantId, quantity);
      await updateCustomerCartMetafield();
    } catch (err) {
      console.error("Update failed:", err);
      btn.disabled = false;
      btn.classList.remove("loading");
      const spinnerRevert = btn.querySelector(".loading__spinner");
      if (spinnerRevert) spinnerRevert.classList.add("hidden");
      const textSpanRevert = btn.querySelector("span");
      if (textSpanRevert) textSpanRevert.classList.remove("hidden");
      return;
    }

    // ── Step 3: Close modal + reload ─────────────────────────────────────────
    if (modal && modal.classList.contains("quick-add-modal")) {
      if (typeof modal.hide === "function") {
        modal.hide(true);
      } else if (typeof modal.close === "function") {
        modal.close();
      } else {
        modal.removeAttribute("open");
        modal.classList.remove("open");
      }
    }
    window.location.reload();
  });

  async function updateCustomerCartMetafield() {
    if (!window?.customer?.id) return; // Only run for logged-in users
    let currentCart = await fetch("/cart.js").then((res) => res.json());

    let cartMetaData =
      typeof window.customer?.metafields?.cart?.itemsdata === "string"
        ? JSON.parse(window.customer.metafields.cart.itemsdata)
        : window.customer?.metafields?.cart?.itemsdata || {};

    if (currentCart?.items?.length === 0) return;

    const cartData = {
      items: currentCart?.items.map((item) => ({
        variant_id: item?.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}, // line-item attributes
      })),
      attributes: currentCart.attributes || {}, // cart-level attributes
      note: currentCart.note || "",
    };

    const metaUpdateRes = await window.mapclubFetch("customer-cart-data", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: window.customer?.id,
        cartData,
      }),
    });
    const data = await metaUpdateRes.json();
    if (data) {
      // ✅ Safely extract new metafield value
      const newItemsData = data?.metafield?.value
        ? data.metafield.value
        : window.customer?.metafields?.cart?.itemsdata;

      // ✅ If you need it locally (for logic or display)
      window.customer = {
        ...window.customer,
        metafields: {
          ...window.customer?.metafields,
          cart: {
            ...window.customer?.metafields?.cart,
            itemsdata: newItemsData,
          },
        },
      };
    }
  }
}
